"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _Constants = require("../../Constants");

var _Panel = require("../../selectors/Panel");

var _FromUrlPanelContainer = _interopRequireDefault(require("../../containers/browser/FromUrlPanelContainer"));

var _BulkImportFromUrlPanel = _interopRequireDefault(require("../image-import/BulkImportFromUrlPanel"));

var _BrowsePanel = _interopRequireDefault(require("./BrowsePanel"));

var _FolderPanel = _interopRequireDefault(require("./FolderPanel"));

var _SearchPanel = _interopRequireDefault(require("./SearchPanel"));

var _panelToComponent;

var panelToComponent = (_panelToComponent = {}, (0, _defineProperty2.default)(_panelToComponent, _Constants.Panels.BROWSE, _BrowsePanel.default), (0, _defineProperty2.default)(_panelToComponent, _Constants.Panels.FOLDER, _FolderPanel.default), (0, _defineProperty2.default)(_panelToComponent, _Constants.Panels.SEARCH, _SearchPanel.default), (0, _defineProperty2.default)(_panelToComponent, _Constants.Panels.FROM_URL, _FromUrlPanelContainer.default), (0, _defineProperty2.default)(_panelToComponent, _Constants.Panels.BULK_IMPORT_FROM_URL, _BulkImportFromUrlPanel.default), _panelToComponent);

var getPanel = function getPanel(panel) {
  return panelToComponent[panel] ? panelToComponent[panel] : _BrowsePanel.default;
};

var ActivePanel = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ActivePanel, _Component);

  function ActivePanel() {
    (0, _classCallCheck2.default)(this, ActivePanel);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ActivePanel).apply(this, arguments));
  }

  (0, _createClass2.default)(ActivePanel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          activePanel = _this$props.activePanel,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["activePanel"]);
      var Panel = getPanel(activePanel);
      return _react.default.createElement(Panel, rest);
    }
  }]);
  return ActivePanel;
}(_react.Component);

ActivePanel.propTypes = {
  type: _propTypes.default.oneOf(Object.keys(_Constants.DrawerTypes)).isRequired,
  activePanel: _propTypes.default.oneOf(Object.keys(_Constants.Panels)).isRequired,
  onInsert: _propTypes.default.func.isRequired,
  isPanelInactive: _propTypes.default.bool,
  disableUpload: _propTypes.default.bool.isRequired
};
ActivePanel.defaultProps = {
  isPanelInactive: false,
  withPanelNavigator: false
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    activePanel: (0, _Panel.getActivePanel)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(ActivePanel);

exports.default = _default;
module.exports = exports.default;